import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Wide-screen (xl+, >=1280px) two-column list/detail split shared by the
 * list pages (Estimates, Clients & Leads, Active Jobs) — the biggest
 * workflow win of the wide-screen pass: the selected record's detail sits
 * in a right-hand panel instead of requiring a navigate-away-and-back.
 * Collapses to the existing single-column layout below xl, unchanged —
 * `detail` is only actually visible there because the record components
 * that fill this slot (JobDetailSheet, ContactProfileSheet, ...) render
 * themselves as a Sheet overlay below xl regardless of this wrapper.
 */
export const MasterDetailGrid = ({ list, detail, className }) => (
  <div
    className={cn(
      'xl:grid xl:grid-cols-[minmax(0,1fr)_440px] xl:gap-5 xl:items-start',
      className
    )}
  >
    <div className="min-w-0">{list}</div>
    <div className="hidden xl:block">{detail}</div>
  </div>
);

export default MasterDetailGrid;
